import Vue from 'vue'
import Router from 'vue-router'

const Layout = resolve => require(['@/layout/Layout'], resolve)

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Layout,
    redirect: '/home',
    children: [{
        path: 'home',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/Home'], resolve)
      }, {
        path: 'employee',
        meta: {
          protected: true,
          roles: ''
        },
        component: resolve => require(['@/views/employee/Index'], resolve)
      }, {
        path: 'department',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/unit/Index'], resolve)
      }, {
        path: 'wasteCollectionRecord',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteCollectionRecord/Index'], resolve)
      }, {
        path: 'wasteRecord',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteRecord/Index'], resolve)
      }, {
        path: 'wasteLot',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteLot/Index'], resolve)
      }, {
        path: 'packingRecord',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/packingRecord/Index'], resolve)
      },
      {
        path: 'abnormalRecords',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/abnormalRecords/Index'], resolve)
      },
      {
        path: 'warningRecords',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/warningRecords/Index'], resolve)
      }, {
        path: 'wms/inbound',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/receiptOrder/Index'], resolve)
      }, {
        path: 'wms/outbound',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/deliveryOrder/Index'], resolve)
      }, {
        path: 'wms/warehouse',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/warehouse/Index'], resolve)
      },
      {
        path: 'wms/location',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/location/Index'], resolve)
      }, {
        path: 'wms/inventory',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/inventory/Index'], resolve)
      }, {
        path: 'report/wasteProduceReport',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteProduceReport/Index'], resolve)
      }, {
        path: 'report/wasteInboundReport',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteInboundReport/Index'], resolve)
      }, {
        path: 'report/wasteOutboundReport',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteOutboundReport/Index'], resolve)
      },
      {
        path: 'report/wasteCollection',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteCollection/Index'], resolve)
      },
      {
        path: 'report/departmentWaste',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/departmentWaste/Index'], resolve)
      },
      {
        path: 'report/communityWaste',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/communityWaste/Index'], resolve)
      },
      {
        path: 'report/dayInOutWaste',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/dayInOutWaste/Index'], resolve)
      },
      {
        path: 'report/yearInOutWaste',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/yearInOutWaste/Index'], resolve)
      }, {
        path: 'disponseCompany',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/disponseCompany/Index'], resolve)
      },
      {
        path: 'transitVehicles',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/transitVehicles/Index'], resolve)
      },
      {
        path: 'equipment',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/equipment/Index'], resolve)
      },
      {
        path: 'synchronous',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/synchronous/Index'], resolve)
      }, {
        path: 'wasteSource',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/wasteSource/Index'], resolve)
      }, {
        path: 'book/medicalWasteBook',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/medicalWasteBook/Index'], resolve)
      },
      {
        path: 'duplicateWaste',
        meta: {
          protected: true
        },
        component: resolve => require(['@/views/duplicateWaste/Index'], resolve)
      }
    ]
  }, {
    path: '/signin',
    name: 'Signin',
    component: resolve => require(['@/views/Signin'], resolve)
  }, {
    path: '/signup',
    name: 'Signup',
    component: resolve => require(['@/views/Signup'], resolve)
  },{
    path: '/passwordUpdate',
    name: 'PasswordUpdate',
    component: resolve => require(['@/views/PasswordUpdate'], resolve)
  },
   {
    path: '/findPassword',
    name: 'FindPassword',
    component: resolve => require(['@/views/FindPassword'], resolve)
  }, {
    path: '/beMember',
    name: 'BeMember',
    component: resolve => require(['@/views/BeMember'], resolve)
  }, {
    path: '/error',
    name: 'Error',
    component: resolve => require(['@/views/Error'], resolve)
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js